import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import cookieHelper from "helpers/getCookieData";

import { getUserRole, isSuperAdminUser } from "helpers/permissionHelper";
import { isPaymentModuleEnabled, isMultiChairEnabled, isReportsEnabled } from "helpers/tenantModuleHelper";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !cookieHelper.getCookie("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      const role = getUserRole();
      const isSuper = isSuperAdminUser();
      const currentPath = props.location?.pathname || "";
      const allowedPatientPaths = ["/portal", "/profile", "/logout", "/clinic", "/book"];

      // 1. Patient Portal Restriction
      if (
        isAuthProtected &&
        role === "patient" &&
        !allowedPatientPaths.some(p => currentPath.startsWith(p))
      ) {
        return <Redirect to="/portal" />;
      }

      // 2. Strict SuperAdmin Route Protection: Only SuperAdmin can access /superadmin
      if (isAuthProtected && currentPath.startsWith("/superadmin") && !isSuper) {
        return <Redirect to="/dashboard" />;
      }

      // 3. SuperAdmin Default Landing: SuperAdmin goes to /superadmin instead of clinic dashboard
      if (isAuthProtected && isSuper && (currentPath === "/dashboard" || currentPath === "/clinics")) {
        return <Redirect to="/superadmin" />;
      }

      // 4. Module Level Route Protections for Tenant Clinics
      if (isAuthProtected && !isSuper) {
        if (currentPath.startsWith("/accounts") && !isPaymentModuleEnabled()) {
          return <Redirect to="/dashboard" />;
        }
        if (currentPath.startsWith("/chairs") && !isMultiChairEnabled()) {
          return <Redirect to="/dashboard" />;
        }
        if (currentPath.startsWith("/reports") && !isReportsEnabled()) {
          return <Redirect to="/dashboard" />;
        }
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware;
